import(/* webpackMode: "eager" */ "/home/runner/work/thriwe-marketplace-ui/thriwe-marketplace-ui/app/(pages)/(prelogin)/(registerlogin)/layout.tsx");
